// Libs
import classNames from 'classnames/bind';
import { Spinner } from '@instructure/ui';
// Components, Layouts, Pages
// Others
// Styles, images, icons
import styles from './Loading.module.scss';

const cx = classNames.bind(styles);

const Loading = () => {
  return (
    <div className={cx('loadingContainer')}>
      <Spinner renderTitle='Loading' size='small' />
    </div>
  );
};

export default Loading;
